<div class="mb-[24px] text-headline-5" *ngIf="title">
  {{ title }}
</div>
<div class="mb-[24px] text-body-2" *ngIf="subTitle">
  {{ subTitle }}
</div>
